import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerCloseAction} from '../../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerIcon} from '../../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';
import {BannerText} from '../../../../../libs/shared/ui/src/components/banners/bannerText';

/*
 * Props.
 */

interface MacrosSuccessBannerProps {
  name: string;
  onDismissClick: () => void;
}

/*
 * Component.
 */

export const MacrosSuccessBanner: FC<MacrosSuccessBannerProps> = ({name, onDismissClick}) => (
  <Banner bannerType={BannerTypesEnum.INLINE} priority={BannerPrioritiesEnum.INFORMATION}>
    <BannerCloseAction onClick={onDismissClick} />
    <BannerIcon iconName="lightning" />
    <BannerText>
      <Trans id="macros-success-banner">{name} completed</Trans>
    </BannerText>
  </Banner>
);
